import React from 'react'
import { Helmet } from 'react-helmet';
import Menu from '../component/Menu';
import HeaderCasestudy from '../component/HeaderCasestudy';
import Casestudybody11 from '../component/Casestudybody11';
import FooterNew from '../component/FooterNew';

import thumbimg from '../images/case-study-client11.webp'

const CaseStudy11 = ({setBlank}) => {
    const headings = "<h2>Private Equity <span>Valuation Model</span></h2><h4>for an Investment Firm</h4>";

  return (
    <>
    <Helmet>
      <title>Private Equity Valuation Model for an Investment Firm</title>
      <meta property="og:image" content={thumbimg} /> 
      <meta property="og:title" content="Private Equity Valuation Model for an Investment Firm" />
      <meta property="og:description" content="Private Equity Valuation Model for an Investment Firm"/>
    </Helmet>

    <Menu setBlank={setBlank} />
    <HeaderCasestudy headings={headings} class="header-casestudy11" />  
    <Casestudybody11 />
    <FooterNew setBlank={setBlank} />
    </>

  )
}

export default CaseStudy11
